// extracted by mini-css-extract-plugin
export default {"modal":"ChunksModal_modal__s0hC3","fileName":"ChunksModal_fileName__GxnKB","noChunks":"ChunksModal_noChunks__RFVpe","snippet":"ChunksModal_snippet__f9zLl"};